<template>
    <page showBackButton>
        <h1>Video Meeting Terminvereinbarung</h1>
        <ion-list>
            <ion-list-header>
                Kundendaten
            </ion-list-header>
            <ion-item>
                <ion-label>Vorname</ion-label>
                <b>{{ vorname }}</b>
            </ion-item>
            <ion-item>
                <ion-label>Nachname</ion-label>
                <b>{{ nachname }}</b>
            </ion-item>
            <ion-item>
                <ion-label>E-Mail</ion-label>
                <b>{{ email }}</b>
            </ion-item>
            <ion-item>
                <ion-label>Datum</ion-label>
                <b>{{ datum }}</b>
            </ion-item>
            <ion-item>
                <ion-label>Uhrzeit</ion-label>
                <b>{{ uhrzeit }}</b>
            </ion-item>
        </ion-list>
        <base-datetime
            label="Gewähltes Datum"
            v-model="datePicked"
            id="datum"
            :showNativeInput="true"
            placeholder="TT.MM.JJJJ"
            infoText="Das Datum muss im Format TT.MM.JJJJ eingegeben werden."
            class="ion-margin-bottom"
            isFuture
        ></base-datetime>
        <base-datetime
            label="Gewählte Uhrzeit"
            v-model="timePicked"
            id="uhrzeit"
            displayFormat="HH:mm"
            pickerFormat="HH:mm"
        ></base-datetime>
        <ion-button expand="block" class="ion-margin-top" @click="submitForm()"
            >Termin vereinbaren</ion-button
        >
    </page>
</template>

<script>
import Page from "@/components/Page";
import BaseDatetime from "@/components/BaseDatetime";
import { videoCallGenerate } from "@/api/coachcontact";
import { DateFormatter } from "@/utils/date";

export default {
    components: {
        Page,
        BaseDatetime,
    },
    data() {
        return {
            id: "",
            vorname: "",
            nachname: "",
            email: "",
            datum: "",
            uhrzeit: "",
            datePicked: "",
            timePicked: "",
        };
    },
    mounted() {
        if (this.$route.query.id) {
            this.id = this.$route.query.id;
        }
        if (this.$route.query.vorname) {
            this.vorname = this.$route.query.vorname;
        }
        if (this.$route.query.nachname) {
            this.nachname = this.$route.query.nachname;
        }
        if (this.$route.query.email) {
            this.email = this.$route.query.email;
        }
        if (this.$route.query.datum) {
            this.datum = this.$route.query.datum;
        }
        if (this.$route.query.uhrzeit) {
            this.uhrzeit = this.$route.query.uhrzeit;
        }
    },
    methods: {
        submitForm() {
            this.$store.commit("setLoading", true);
            let date = this.datePicked;
            if (this.datePicked !== "" && this.datePicked.charAt(2) !== ".") {
                date = DateFormatter.formatDate(
                    new Date(this.datePicked),
                    "DD.MM.YYYY"
                );
            }
            let time = "";
            if (this.timePicked !== "") {
                time = DateFormatter.formatDate(
                    new Date(this.timePicked),
                    "HH:mm"
                );
            }
            videoCallGenerate({
                date: date,
                time: time,
                email: this.email,
                firstname: this.vorname,
                lastname: this.nachname,
                beraterid: this.id,
                password: sessionStorage.getItem("ppw"),
            }).then((response) => {
                if (response.data.Status === 200) {
                    this.$ionic.alertController
                        .create({
                            header: "Erfolgreich abgesendet",
                            // message: "Möchtest du dieses Dokument wirklich löschen?",
                            buttons: [
                                {
                                    text: "Ok",
                                    role: "cancel",
                                },
                            ],
                        })
                        .then((a) => {
                            a.onDidDismiss().then(() => {
                                this.$router.push({ name: "dashboard" });
                            });
                            a.present();
                        });
                }
            });
        },
    },
};
</script>

<style></style>
